module.exports = __webpack_public_path__ + "static/media/usi_check.205c7652.jpg";